/**
 * little-state-machine reducer for form state
 * Supports one of each form type
 */
export default function clearForms(state, payload) {
    return {
        ...state,
        forms: {},
    };
}
